import { w3cwebsocket as ws } from 'websocket';
import { MelosPlayerStatus } from '@/components/MelosPlayer.vue';

export interface IMelosControllerService {
  connect(ip: string, deviceId: string): void;
  disconnect(): void;
  sendCommand(command: string, args: string[]): void;
}

let that: any;

export class MelosControllerService implements IMelosControllerService {
  private socket: any;
  private store: any;
  private deviceId: string | undefined;

  constructor(vuexStore: any) {
    this.store = vuexStore;
    that = this;
  }

  public connect(ip: string, deviceId: string): void {
    this.disconnect();
    this.deviceId = deviceId;
    this.socket = new ws(`ws://${ip}:9090`);
    this.socket.onclose = this.onConnectionClosed;
    this.socket.onerror = this.onConnectionClosed;
    this.socket.onmessage = this.onMessageReceived;
    this.socket.onopen = this.onConnectionEstablished;
  }

  public disconnect(): void {
    if (this.socket !== undefined) {
      this.socket.close();
    }
  }

  public sendCommand(command: string, args: string[]) {
    if (this.socket === undefined) {
      return;
    }
    this.socket.send(JSON.stringify({
      command,
      args,
    }));
  }

  private onConnectionClosed(): void {
    that.store.commit('setConnectedDevice', undefined);
  }

  private onMessageReceived(message: any): void {
    const data = JSON.parse(message.data);
    if (data.currentElapsedTime !== undefined) {
      that.store.commit('setPlayerData', { currentElapsedTime: data.currentElapsedTime });
      return;
    }
    if (data.playerStatus !== undefined) {
      const playerData: any = {
        currentElapsedTime: data.playerStatus.currentElapsedTime,
        author: data.playerStatus.author,
        trackDuration: data.playerStatus.duration,
        link: data.playerStatus.link !== '' ? data.playerStatus.link : undefined,
        currentStatus: data.playerStatus.paused ? MelosPlayerStatus.PAUSED : MelosPlayerStatus.PLAYING,
        provider: data.playerStatus.provider,
        stationId: data.playerStatus.stationId,
        trackTitle: data.playerStatus.trackTitle,
        loop: data.playerStatus.loop,
        volume: data.playerStatus.volume,
      };
      if (data.items !== undefined) {
        playerData.targetStatus = playerData.currentStatus;
        that.store.commit('setDeviceStations', data.items);
      }
      that.store.commit('setPlayerData', playerData);
    }
  }

  private onConnectionEstablished(): void {
    that.store.commit('setConnectedDevice', that.deviceId);
  }

}
